import PropTypes from 'prop-types';
import React, {Children} from 'react';

const RideRequestStepper = ({children, step}) => (
  <div>{Children.toArray(children)[step]}</div>
);

RideRequestStepper.propTypes = {
  children: PropTypes.node,
  step: PropTypes.number,
};

export default RideRequestStepper;



// WEBPACK FOOTER //
// ./src/ondemand/components/RideRequestStepper.js